export default "__VITE_ASSET__7851a334__"